export const formatEmail = (email: string) => {
	return email.toLowerCase().trim();
};
